import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    :not(input):not(textarea):not(button) {
        user-select: text;
    }

    /* Hide scrollbars globally */
    * {
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
    }

    *::-webkit-scrollbar {
        display: none; /* WebKit browsers (Chrome, Safari, Edge) */
    }

    /* Ensure scrolling still works */
    html, body {
        overflow-x: hidden;
        overflow-y: auto;

        --safe-area-max-inset-bottom: env(safe-area-max-inset-bottom, 36px);
    }

   
    [elevation="halfcards_And_Popups"] {
       max-width: 512px;
       margin: auto;
    }

    /* Hide spinner arrows for number inputs */
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="number"] {
        -moz-appearance: textfield;
        appearance: textfield;
    }
`;
